<template>
  <div>
    <SchoolEmployeeApplicationTable
      :items="items"
      :is-busy="isBusyStore"
      :pagination="pagination"
    >
    </SchoolEmployeeApplicationTable>

    <div class="d-flex justify-content-end" v-if="items.length">
      <b-pagination
        size="lg"
        align="right"
        class="pt-5"
        @change="changePage"
        v-model="pagination.current_page"
        :total-rows="pagination.total"
        :per-page="pagination.per_page"
        aria-controls="employee-page-table"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import SchoolEmployeeApplicationTable from "@/modules/school/components/management/leave/application/SchoolEmployeeApplicationTable";
import { mapGetters } from "vuex";

export default {
  name: "SchoolTeacherEmployeeApplication",
  components: { SchoolEmployeeApplicationTable },
  data() {
    return {
      isBusy: false,
    };
  },
  mounted() {
    this.fetch();
  },
  methods: {
    /**
     * Fetch
     */
    fetch() {
      this.isBusy = true;
      this.$store
        .dispatch("fetchTeacherLeaveApplicationApprovalList")
        .finally(() => (this.isBusy = false));
    },

    /**
     * Change page.
     *
     * @param page
     */
    changePage(page) {
      this.$store.commit("setTeacherLeaveApplicationApprovalListPage", page);
      this.fetch();
    },
  },
  computed: {
    ...mapGetters({
      items: "getTeacherLeaveApplicationApprovalList",
      pagination: "getTeacherLeaveApplicationApprovalPagination",
      isBusyStore: "setTeacherLeaveApplicationApprovalBusy",
    }),
  },
};
</script>

<style scoped></style>
